import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../components/authProvider';

// Our Components
import Sidebar from '../components/sidebar';

export const ProtectedRoute = () => {
  const { token } = useAuth();

  // Check if the user is authenticated
  if (!token) {
    // If not authenticated, redirect to the login page
    return <Navigate to='/login' />;
  }

  // If authenticated, render the child routes
  return (
    <div className='container-fluid'>
      <div className='row flex-xl-nowrap'>
        <Sidebar />
        <Outlet />
      </div>
    </div>
  );
};
